webpackJsonp([93244700622746],{

/***/ 900:
/***/ (function(module, exports) {

	module.exports = {"data":{"cardsJson":{"starting_zone":"codex","mid_text_1":null,"sirlins_filename":"0029_backstabber.jpg","type":"Unit","subtype":"Rogue","cost":3,"ATK":3,"HP":3,"rules_text_1":"Invisible (To opponents without a detector, this is untargetable, unattackable, and can sneak past patrollers. While patrolling, this is attackable.)","rules_text_2":null,"rules_text_3":null,"base_text_1":null,"base_text_2":null,"ATK_1":null,"HP_1":null,"mid_level":null,"name":"Backstabber","mid_text_2":null,"ATK_2":null,"HP_2":null,"max_level":null,"max_text_1":null,"max_text_2":null,"ATK_3":null,"HP_3":null,"flavor_text":"Don't let him slip behind you.","color":"Neutral","spec":"Finesse","bottom":"Tech II","rulings":[],"keywords":["Invisible"],"slug":"backstabber"},"site":{"siteMetadata":{"title":"Codex Card Database"}}},"pathContext":{"slug":"backstabber","keywords":["Invisible"],"imageRegex":"/backstabber.jpg/"}}

/***/ })

});


// WEBPACK FOOTER //
// path---card-backstabber-975f073fe31d96290510.js